import { css } from 'styled-components';
export const styles = (theme) => css `
  ${theme.basic}

  &.secondary {
    ${theme.secondary}
  }

  &.bold {
    ${theme.bold}
  }

  &.error {
    ${theme.error}
  }

  &.small {
    ${theme.small}
  }

  &.code-snippet {
    ${theme['code-snippet']}
  }

  &.heading1 {
    ${theme.heading1}
  }

  &.heading2 {
    ${theme.heading2}
  }

  &.heading3 {
    ${theme.heading3}
  }
`;
//# sourceMappingURL=styles.js.map